import Header from "../../layouts/AuthLayout/header/header";
import CategorySection from "./category-section";
import Footer from "./footer";
import MainSlider from "./main-slider";
import NewArrivals from "./new-arrivals-section";

export default function HomePage() {
  return (
    <>
      {/* Header start  */}
      <Header />
      {/* Header End  */}
      {/* Main Slider Start */}
      <MainSlider />
      {/* Main Slider End */}
      {/*  category Section Start */}
      <CategorySection />
      {/*category Section End */}

      {/* ec Banner Section Start */}
      {/* TODO: need work here */}
      {/* <BannerSection /> */}
      {/* ec Banner Section End */}

      {/* Product tab Area Start */}
      {/* <ExclusiveProducts /> */}
      {/* ec Product tab Area End */}

      {/* Trending Item Start */}
      <NewArrivals />
      {/* Trending Item end */}

      {/*  services Section Start */}
      {/* <ServiceSection /> */}
      {/*services Section End */}

      {/* ec testimonial Start */}
      {/* <TestimonialSection /> */}
      {/* ec testimonial end */}

      {/* Ec Instagram Start */}
      {/* <InstagramSection /> */}
      {/* Ec Instagram End */}

      {/* Ec Brand Section Start */}
      {/* <BrandSection /> */}
      {/* Ec Brand Section End */}

      {/* Footer Start */}
      <Footer />
      {/* Footer Area End */}
    </>
  );
}
